import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Typography } from 'antd';
import { OrganizationFormItem } from './OrganizationFormItem';
import { WorkstationFormItem } from './WorkstationFormItem';
import { CreationDateFormItem } from './CreationDateFormItem';
import { CompanyFormItem } from './CompanyFormItem';
import { SectorFormItem } from './SectorFormItem';
import { LineFormItem } from './LineFormItem';
import { RpnFormItemInitial } from './RpnFormItemInitial';
import { RpnFormItemFinal } from './RpnFormItemFinal';
import { useDataExtractionReport } from '@/context/DataExtractionReport';
import * as S from './styles';

const { Text } = Typography;

export function DrawerForm() {
	const { dataExtractionReport } = useDataExtractionReport();

	return (
		<Row gutter={[0, 32]}>
			<Col span={24}>
				<OrganizationFormItem disabled={!!dataExtractionReport?.organization_id} />
			</Col>
			<Col span={24}>
				<CompanyFormItem disabled={!!dataExtractionReport?.company_id} />
			</Col>
			<Col span={24}>
				<SectorFormItem disabled={!!dataExtractionReport?.sector_id} />
			</Col>
			<Col span={24}>
				<LineFormItem disabled={!!dataExtractionReport?.line_id} />
			</Col>
			<Col span={24}>
				<WorkstationFormItem disabled={!!dataExtractionReport?.workstation_id} />
			</Col>
			<Col span={24}>
				<CreationDateFormItem />
			</Col>
			<Col span={24}>
				<S.CustomRow gutter={[8, 0]} align="middle">
					<RpnFormItemInitial />
					<Col span={2} style={{ textAlign: 'center' }}>
						<Text>{I18n.get('to')}</Text>
					</Col>
					<RpnFormItemFinal />
				</S.CustomRow>
			</Col>
		</Row>
	);
}
